<template>
  <form @submit.prevent="submit">
    <div>{{ $t("global.are-you-sure-delete") }}</div>
    <hr />
    <h1>{{ site.domain }}</h1>
    <hr />
    <div class="form-buttons">
      <Btn
        class="mr-2"
        variant="light"
        type="button"
        :disabled="isSubmitting"
        @click="cancel"
        data-test="cancel-delete-site-button"
      >
        {{ $t("global.cancel") }}
      </Btn>
      <Btn
        variant="danger"
        type="submit"
        :disabled="isSubmitting"
        :loading="isSubmitting"
        data-test="delete-site-button"
      >
        {{ $t("global.delete-site") }}
      </Btn>
    </div>
  </form>
</template>

<script>
import Btn from "@/components/display/Btn";
import i18n from "@/i18n";
import { ref } from "@vue/composition-api";
import store from "@/store";

export default {
  name: "SiteDeleteForm",
  props: {
    site: {
      type: Object,
      required: true,
    },
  },
  components: {
    Btn,
  },
  setup(props, { emit, root }) {
    const isSubmitting = ref(false);

    const cancel = () => {
      emit("close");
    };

    const submit = () => {
      isSubmitting.value = true;

      store
        .dispatch("sites/delete", { id: props.site.id, planId: props.site.plan.id })
        .then(() => {
          // show toast informing the user their site will be deleted soon
          store.dispatch("toasts/addToast", {
            variant: "info",
            message: i18n.t("toasts.site-removing-message", { name: props.site.domain }),
          });
          emit("close");
        })
        .catch(() => {
          // show a toast informing the user their site failed to delete
          store.dispatch("toasts/addToast", {
            variant: "error",
            message: root.$t("toasts.site-delete-error-message", { name: props.site.domain }),
          });
        })
        .finally(() => {
          isSubmitting.value = false;
        });
    };

    return {
      isSubmitting,
      submit,
      cancel,
    };
  },
};
</script>

<style lang="scss" scoped>
.form-buttons {
  text-align: right;
  padding-top: 2rem;
}
</style>
